import { render, staticRenderFns } from "./ExibirImagemApiModal.vue?vue&type=template&id=2961d762"
import script from "./ExibirImagemApiModal.vue?vue&type=script&lang=js"
export * from "./ExibirImagemApiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports